import { Deserializable } from './deserializable';

export interface IEntityDto {
    id: number | undefined;
}

export class EntityDto extends Deserializable implements IEntityDto {
    id: number | undefined;
}
